import React from 'react'
import { Calculator, ArrowDownCircle } from 'lucide-react'
import type { Movement } from '../../types/@types/cash'
import { formatCOP } from '../../utils/money'

interface MovementListProps {
  movements: Movement[]
}

export const MovementList: React.FC<MovementListProps> = ({ movements }) => {
  const typeLabels: Record<string, string> = {
    sale: 'Venta',
    withdraw: 'Retiro',
    expense: 'Gasto',
  }
  return (
    <div className="bg-white rounded-xl shadow-md p-4">
      <h3 className="text-lg font-semibold mb-2">Movimientos del Día</h3>
      {movements.length === 0 ? (
        <div className="flex flex-col items-center py-8 text-gray-500">
          <Calculator className="w-8 h-8 mb-2" />
          <p>No hay movimientos registrados</p>
        </div>
      ) : (
        <ul className="space-y-1">
          {movements.map(m => {
            const amount = Number(m.amount) || 0
            const isExpense = m.type === 'expense'
            const isWithdraw = m.type === 'withdraw'
            return (
              <li key={m.id} className="border-b pb-1 last:border-0">
                <div className="flex justify-between items-center">
                  {isExpense ? (
                    <span className="flex items-center gap-1">
                      <ArrowDownCircle className="w-4 h-4 text-red-600" />
                      <span className="px-2 py-0.5 rounded bg-red-100 text-red-700 text-xs">
                        Gasto
                      </span>
                    </span>
                  ) : isWithdraw ? (
                    <span className="flex items-center gap-1">
                      <ArrowDownCircle className="w-4 h-4 text-orange-600" />
                      <span className="px-2 py-0.5 rounded bg-orange-100 text-orange-700 text-xs">
                        Retiro
                      </span>
                    </span>
                  ) : (
                    <div className="flex flex-col">
                      <span className="font-medium">{typeLabels[m.type] || m.type}</span>
                      {m.products && m.products.length > 0 && (
                        <div className="mt-1 pl-2 border-l-2 border-gray-200">
                          {m.products.map((p, idx) => (
                            <p key={idx} className="text-xs text-gray-600">
                              {p.quantity}x {p.name}
                            </p>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                  <div className="text-right">
                    <span className={isExpense || isWithdraw ? 'text-red-600 font-bold' : 'font-bold'}>
                      {formatCOP(amount)}
                    </span>
                    {m.reason && (
                      <p className="text-xs text-gray-400">{m.reason}</p>
                    )}
                  </div>
                </div>
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}
